var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-spinner"},[_c('span',[_vm._v("Loading "+_vm._s(_vm.p_txt)+"... ")]),_c('span',{staticClass:"spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }